import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight, faPlayCircle, faPlus, faPowerOff } from '@fortawesome/free-solid-svg-icons';

// Fontawesome Icon registration
library.add(faPowerOff, faPlayCircle, faArrowRight, faPlus);
